import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {
    BrowserRouter as Router,
} from 'react-router-dom';

import { ConfigProvider } from 'antd';
import ru from 'antd/es/locale/ru_RU';

import { QueryClientProvider } from '@tanstack/react-query';
import store from '@utils/redux/configureStore';
import { queryClient, registerAppRemountHandler } from '@utils/appLifecycle';

import { GlobalConstants } from '../constants/global';
import { Loader } from '../ui/atoms/loader';
import { App } from '../ui/pages/app';
import '../utils/configureMobX';

import '../styles/style.scss';
// Официальные стили react-image-gallery. Подключены здесь (после style.scss,
// который тянет устаревший ручной порт src/styles/image-gallery.scss с теми же
// селекторами и той же специфичностью) — только так порядок каскада детерминирован
// в обоих режимах сборки. Точечный импорт внутри отдельного компонента ловит
// разный порядок CSS-чанков между dev (style-loader, порядок исполнения JS)
// и prod (MiniCssExtractPlugin + splitChunks, порядок по графу чанков) — из-за
// этого фикс работал локально, но не после деплоя.
import 'react-image-gallery/styles/image-gallery.css';

import * as pdfjs from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import ErrorBoundary from '@pages/errorBoundary/errorBoundary';

let root: ReturnType<typeof createRoot> | null = null;
let mountKey = 0;

export const render = (isLoading = false) => {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    const container = document.getElementById(GlobalConstants.MainRoot);
    if (!root) {
        root = createRoot(container);
    }
    mountKey += 1;
    root.render(
        <QueryClientProvider client={queryClient}>
            <ConfigProvider theme={{
                token: {
                    borderRadius: 6,
                    colorPrimary: '#1677ff',
                    boxShadowTertiary: '0px 2px 5px 2px rgb(118 118 118 / 20%)',
                },
                components: {
                    Table: {
                        borderColor: '#f0f0f0',
                    },
                    Card: {
                        paddingLG: 24,
                    },
                },
            }} locale={ru}>
                <Provider store={store}>
                    <Router>
                        {isLoading ? (
                            <Loader isFullSize={true} />
                        ) : (
                            <ErrorBoundary key={mountKey}>
                                <App />
                            </ErrorBoundary>
                        )}
                    </Router>
                </Provider>
            </ConfigProvider>
        </QueryClientProvider>
    );
};

registerAppRemountHandler(() => render());

render();
